import { SwapVert } from '@mui/icons-material';
import { IconButton, MenuItem } from '@mui/material';
import { Menu, MenuButton } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ItemPriority } from '@retail/products/types';

interface Props {
  handleUpdatePriority: (prio: ItemPriority) => void;
}

export function SwapPriorityMenu({ handleUpdatePriority }: Props) {
  const t = useMyAssortmentTFunction();
  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton component={IconButton} sx={{ padding: 0 }}>
            <SwapVert fontSize="small" />
          </MenuButton>

          <MenuItem
            sx={{
              py: 1,
              bgcolor: 'semantic.tint.green.medium',
              color: 'semantic.tint.green.text',
              ':focus, :hover': { bgcolor: 'semantic.tint.green.strong' },
            }}
            onClick={() => {
              handleUpdatePriority(ItemPriority.TEN);
              onClose();
            }}
          >
            {t('myAssortment.priority.mainPrio')}
          </MenuItem>
          <MenuItem
            sx={{
              py: 1,
              bgcolor: 'semantic.tint.saffron.medium',
              color: 'semantic.tint.saffron.text',
              ':focus, :hover': { bgcolor: 'semantic.tint.saffron.strong' },
            }}
            onClick={() => {
              handleUpdatePriority(ItemPriority.ZERO);
              onClose();
            }}
          >
            {t('myAssortment.priority.underPrio')}
          </MenuItem>
        </>
      )}
    </Menu>
  );
}
